import styled from 'styled-components';
import { Button as DefaultButton } from '@simplywallst/ui-core';

export const Wrapper = styled('blockquote')`
  position: relative;
  display: flex;
  align-items: top;
  margin-bottom: ${({ theme }) => theme.x1spacePx}px;
`;

export const Button = styled(DefaultButton)`
  body[data-theme] & {
    color: var(---s-nav-text-color);

    &:hover {
      box-shadow: inset 0px -1px 0 0 currentColor;
    }

    & > svg {
      fill: currentColor;
    }
  }

  box-shadow: none;
  > svg {
    margin-right: -${({ theme }) => theme.x1spacePx}px;
  }
  &:hover {
    > svg {
      transform: rotate(90deg);
    }
  }
`;
